"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AccountSelect_1 = require("./AccountSelect");
exports.default = AccountSelect_1.default;
//# sourceMappingURL=index.js.map